import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import { reg_userName, reg_email, emailProviderValidator } from "../../../../common/parameters";

import { post } from "../../../actions/general";
import { editUser } from "../../../store/user/actions";

import Form, { InputText, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { IProps } from "./interfaces";

const ChangeTextValue = ({ changingValue, changingName, changingLabel, close }: IProps) => {
    const { locale, formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [value, setValue] = useState(changingValue);
    const [validation, setValidation] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    const submit = () => {
        if (!value) {
            setValidation("required");
            return;
        }
        if (changingName === "username") {
            if (!reg_userName.test(value)) {
                setValidation("incorrectUsernameFormat")
                return;
            }
        }

        if (changingName === "email") {
            if (!reg_email.test(value)) {
                setValidation("incorrectEmailFormat")
                return;
            } else if (!emailProviderValidator(value)) {
                setValidation("bannedEmailProvider")
                return;
            }
        }
        setLoading(true);
        dispatch(post(
            "change-" + changingName,
            { [changingName]: value, lang: locale },
            res => {
                const { data } = res;
                if (data.success) {
                    let user = { ...data.user };
                    dispatch(editUser(user));
                    close();
                    return;
                } else if (data.usedUsername) {
                    setValidation("usernameAlreadyUsed");
                } else if (data.wrongEmailFormat) {
                    setValidation("incorrectEmailFormat");
                } else if (data.emailAlreadyUsed) {
                    setValidation("emailAlreadyUsed");
                } else if (data.first_nameTooShort) {
                    setValidation("shortFirstname");
                } else if (data.first_nameTooLong) {
                    setValidation("longFirstname");
                } else if (data.last_nameTooShort) {
                    setValidation("shortLastname");
                } else if (data.last_nameTooLong) {
                    setValidation("longLastname");
                } else {
                    setValidation("unknownError");
                }
                setLoading(false);
            }
        ));
    };
    const changeValue = (e: React.FormEvent<HTMLInputElement>) => {
        setValue(e.currentTarget.value);
        setValidation(undefined);
    };

    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.modifySomething} values={{ value: changingLabel }} />
                </Title>
                <InputText
                    label={changingLabel}
                    value={value}
                    name={"value"}
                    onChange={changeValue}
                    selectAllOnMount
                    tooltip={changingName === "username" ? formatMessage(messages.usernameTooltip) : undefined}
                    validation={validation}
                    email={changingName === "email"}
                />
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeTextValue;
